import React from 'react';
import { observer } from 'mobx-react-lite';
import { betStore } from '@pascal/pascal-core/shared/core/store';

import { minOdd } from '../betPlaceInfo';
import { emptyArrayForLoop } from '../../../enums/rangeValues';
import { isMobile } from '@pascal/pascal-core';

export const Range = observer(
  ({
    odd,
    rangeRef,
    winNumber,
    rangeValues,
    changeMinValue,
    changeMaxValue,
    minOddOverTaken,
    changeMaxMinValue,
    changeRangeDotValue,
    handleCurrentRangeDot,
  }) => {
    return (
      <div className='w-md-bet-range-wrapper'>
        <div
          className='w-md-bet-range-inner'
          onMouseDown={!isMobile() ? (e) => handleCurrentRangeDot(e) : null}
          onTouchStart={isMobile() ? (e) => handleCurrentRangeDot(e) : null}
        >
          <div className='w-md-bet-range-row'>
            {emptyArrayForLoop.map(({ value }, index) => {
              const showFrom = rangeValues.find((item) => item.from === value)?.from;
              const showTo = rangeValues.find((item) => item.to === value)?.to;
              return (
                <div
                  className={`w-md-bet-range-item ${winNumber === value ? 'is-selected' : ''}`}
                  key={value}
                  data-role={showFrom || showTo || (winNumber === value ? winNumber : null)}
                >
                  <div className='w-md-bet-range-item-inner' />
                </div>
              );
            })}
          </div>
          <div className='w-md-bet-range-cover' ref={rangeRef}>
            {rangeValues.map(({ id, from, to, isDot }, index) => {
              return (
                <div
                  className='w-md-bet-range'
                  onMouseDown={
                    !isMobile()
                      ? (e) => {
                          e.stopPropagation();
                          changeMaxMinValue(e);
                        }
                      : null
                  }
                  onTouchStart={
                    isMobile()
                      ? (e) => {
                          e.stopPropagation();
                          changeMaxMinValue(e);
                        }
                      : null
                  }
                  rangeid={id}
                  key={index}
                  style={{
                    left: `${((from - 5) * 100) / 25}%`,
                    width: `${((to - from) * 100) / 25}%`,
                  }}
                >
                  {!isDot && (
                    <div
                      className='w-md-bet-range-btn left'
                      onMouseDown={!isMobile() ? (e) => changeMinValue(e) : null}
                      onTouchStart={isMobile() ? (e) => changeMinValue(e) : null}
                      rangeid={id}
                    />
                  )}
                  <div className='inner-w-md-bet-range'>
                    <div
                      className={`inner-w-md-bet-range-inside ${
                        !betStore.repliedBetData && (minOddOverTaken || odd < minOdd) ? 'error' : ''
                      }`}
                    >
                      {/* eslint-disable-next-line no-shadow */}
                      {new Array(Math.abs(to - from)).fill(null).map((item, index) => (
                        <div className='inner-w-md-bet-range-inside-item' key={index} rangeid={id} />
                      ))}
                    </div>
                  </div>
                  {!isDot && (
                    <div
                      className='w-md-bet-range-btn right'
                      onMouseDown={!isMobile() ? (e) => changeMaxValue(e) : null}
                      onTouchStart={isMobile() ? (e) => changeMaxValue(e) : null}
                      rangeid={id}
                    />
                  )}
                  {isDot && (
                    <div
                      className='w-md-bet-range-btn left'
                      onMouseDown={!isMobile() ? (e) => changeRangeDotValue(e) : null}
                      onTouchStart={isMobile() ? (e) => changeRangeDotValue(e) : null}
                      rangeId={id}
                    />
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
);
